<template>
  <div class="row-history">
    <component
      :is="report"
      :firstDowntime2="firstDowntime2"
      :firstDowntime="firstDowntime"
      :partcurrent="partcurrent"
      :downspeed="downspeed"
      :upspeed="upspeed"
      :ashReport="ashReport"
      :selectItem="selectItem"
      :checkedData="checkedData"
      :depthReport="depthReport"
      :pulpReport="pulpReport"
      :cols="cols"
    ></component>
    <a id="simulation" href=""></a>
    <el-container class="row-con">
      <el-header class="m-filter">
        <div class="wp">
          <div class="filter">
            <el-form ref="filter" class="m-filterbox">
              <div class="right">
                <el-button
                  @click="querychxun"
                  class="btn btn-search"
                  type="primary"
                  icon="el-icon-search"
                  >查询
                </el-button>
                <el-button
                  class="btn btn-reset"
                  native-type="reset"
                  @click="resetClick"
                >
                  <span class="icon icon-reset"></span><span>重置</span>
                </el-button>
                <el-button type="primary" @click="moreConditions()"
                  >更多条件</el-button
                >
                <el-button type="primary" @click="dialogFormVisible = true"
                  >选择参数</el-button
                >
              </div>
              <div class="left">
                <el-form-item class="item g-date">
                  <el-col :span="14" class="date">
                    <el-date-picker
                      value-format="timestamp"
                      type="datetime"
                      prefix-icon=""
                      v-model="startDate"
                      placeholder="选择日期"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
                <div class="item">至</div>
                <el-form-item class="item g-date">
                  <el-col :span="14" class="date">
                    <el-date-picker
                      value-format="timestamp"
                      type="datetime"
                      prefix-icon=""
                      v-model="endDate"
                      placeholder="选择日期"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
                <el-form-item class="item picker picker-device">
                  <el-select v-model="deviceKey" placeholder="请选择设备">
                    <el-option
                      v-for="item in deviceList"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="item input">
                  <el-input
                    class="input"
                    placeholder="请输入桩号"
                    v-model="pileDescribe"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </el-header>
      <!-- 历史列表 -->
      <el-main class="m-table-main">
        <div id="table-content">
          <!-- :cell-style="backgroundColor" -->
          <el-table
            class="jbThead"
            :data="tableData"
            style="width: 100%"
            ref="table"
            row-key="id"
            align="center"
            @selection-change="selectionChange"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column
              type="selection"
              align="center"
              fixed
            ></el-table-column>
            <el-table-column
              :width="columnWidth(index)"
              v-for="(col, index) in cols"
              :key="index"
              :prop="col.prop"
              :label="col.label"
              :formatter="col.formatter"
              min-width="160px"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column fixed="right" v-if="showDetail">
              <template slot-scope="scope">
                <div class="m-edit-btns">
                  <div class="item">
                    <a
                      href="javascript:"
                      class="btn"
                      @click="handleCommand(scope.$index)"
                      >详情</a
                    >
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
      <!-- 选择参数按钮弹出框 -->
      <el-dialog
        title="选择需要展示的参数"
        :visible.sync="dialogFormVisible"
        width="40%"
        center
        top="15vh"
      >
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0"></div>
        <el-checkbox-group
          v-model="checkedFileds"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox
            v-for="item in fieldNames"
            :label="item.prop"
            :key="item.prop"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="medium"
            >取 消</el-button
          >
          <el-button type="primary" @click="confirmShow" size="medium"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 更多条件弹出框 -->
      <el-dialog
        title="更多条件"
        width="40%"
        :visible.sync="dialogFormVisibleMore"
      >
        <div>
          <el-form class="more-filterbox">
            <div class="moreConditions">
              <div class="items">{{ "\xa0\xa0\xa0\xa0\xa0" }}施工桩长(m)</div>
              <el-input class="input" v-model="pileDepth"></el-input>
              <div class="item">至</div>
              <el-input class="input" v-model="pileDepth2"></el-input>
            </div>
            <div class="moreConditions">
              <div class="items">平均灰量(kg/m)</div>
              <el-input class="input" v-model="pileAsh"></el-input>
              <div class="item">至</div>
              <el-input class="input" v-model="pileAsh2"></el-input>
            </div>
            <div class="moreConditions">
              <div class="items">{{ "\xa0\xa0\xa0\xa0" }}累计灰量(kg)</div>
              <el-input class="input" v-model="cumulativePileAsh"></el-input>
              <div class="item">至</div>
              <el-input class="input" v-model="cumulativePileAsh2"></el-input>
            </div>
            <div class="moreConditions">
              <div class="items">{{ "\xa0\xa0\xa0\xa0\xa0" }}成桩时长(s)</div>
              <el-input class="input" v-model="pileTime"></el-input>
              <div class="item">至</div>
              <el-input class="input" v-model="pileTime2"></el-input>
            </div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisibleMore = false">取 消</el-button>
          <el-button type="primary" @click="moreDetermine()">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
    <!-- 详情弹出框 -->
    <el-dialog
      :visible.sync="centerDialogVisible"
      class="m-pop m-pop-detail"
      v-el-dialog-drag
    >
      <div slot="title" class="dialog-header">
        <div class="left">
          <gTabs @change="changeHandle" :current="tab2" :list="tab2List" />
        </div>
        <div class="right">
          <div v-if="show" class="export_echart" @click="download">
            图片下载
          </div>
          <el-dropdown placement="top-start" @command="downLoad">
            <span class="more">报表下载 </span>
            <el-dropdown-menu class="g-dropdown">
              <el-dropdown-item :command="0">
                <span class="icon icon01"></span>
                <span class="name">打印版</span>
              </el-dropdown-item>
              <el-dropdown-item :command="1">
                <span class="icon icon02"></span>
                <span class="name">综合版</span>
              </el-dropdown-item>
              <el-dropdown-item :command="2">
                <span class="icon icon03"></span>
                <span class="name">详细版</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="dialog-content">
        <div class="m-tab-table m-tab-detail" v-show="tab2 === 0">
          <div class="m-table-detail">
            <div class="detailitem">
              <h3>详细数据</h3>
              <div class="box">
                <ul class="ul-detail">
                  <li class="s1">
                    <div class="inner">
                      <div class="item">
                        <div class="tit">桩号</div>
                        <div
                          class="value valuepile"
                          :title="this.selectItem.pileDescribe"
                        >
                          {{ selectItem.pileDescribe }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">桩机编号</div>
                        <div class="value">{{ selectItem.deviceKey }}</div>
                      </div>
                      <div class="item">
                        <div class="tit">开始时间</div>
                        <div class="value">
                          {{ selectItem.beginTime | datafilters }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">结束时间</div>
                        <div class="value">
                          {{ selectItem.endTime | datafilters }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">施工桩长</div>
                        <div class="value">
                          {{ selectItem.depth | numfilters }}(m)
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="s2">
                    <div class="inner">
                      <div class="item">
                        <div class="tit">初搅深度(m)</div>
                        <div class="value">
                          {{ selectItem.frDepth | numfilters }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">复搅深度(m)</div>
                        <div class="value">
                          {{ selectItem.reDepth | numfilters }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">空搅深度(m)</div>
                        <div class="value">
                          {{ selectItem.emDepth | numfilters }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">下钻速度(cm/min)</div>
                        <div class="value">
                          {{ selectItem.downSpeed | numfilters(1) }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">提钻速度(cm/min)</div>
                        <div class="value">
                          {{ selectItem.upSpeed | numfilters(1) }}
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="s3">
                    <div class="inner">
                      <div class="item">
                        <div class="tit">水灰比(:1)</div>
                        <div class="value">
                          {{ selectItem.waterCementRatio | numfilters }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">累计浆量(L)</div>
                        <div class="value">
                          {{ selectItem.cumulativePulp | numfilters(1) }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">累计灰量(kg)</div>
                        <div class="value">
                          {{ selectItem.cumulativeAsh | numfilters(1) }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">平均浆量(L/m)</div>
                        <div class="value">
                          {{ selectItem.averagePulp | numfilters }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">平均灰量(kg/m)</div>
                        <div class="value">
                          {{ selectItem.averageAsh | numfilters }}
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="s4">
                    <div class="inner">
                      <div class="item">
                        <div class="tit">成桩时间(min)</div>
                        <div class="value">
                          {{ selectItem.pileTime | minfilters }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">桩端电流(A)</div>
                        <div class="value">
                          {{ selectItem.pileTopCurrent | numfilters(1) }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">最大斜度(%)</div>
                        <div class="value">
                          {{ selectItem.xAngle | numfilters(1) }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">最大电流(A)</div>
                        <div class="value">
                          {{ selectItem.maxCurrent | numfilters(1) }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">喷浆压力(MPa)</div>
                        <div class="value">
                          {{ selectItem.averagePressure | numfilters }}
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <br />
            <h3>段数据列表</h3>
            <el-table
              ref="saveTable"
              class="m-table-save m_table_save_height"
              :data="selectItem.data"
              style="width: 100%; margin-top: 20px"
              height="28em"
            >
              <el-table-column
                property="partId"
                label="序号"
                min-width="4.33%"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="partDeep"
                label="段深度(m)"
                min-width="8.83%"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.partDeep | numfilters }}
                </template>
              </el-table-column>
              <el-table-column
                property="partPulp"
                label="段浆量(L)"
                min-width="8.83%"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.partPulp | numfilters }}
                </template>
              </el-table-column>
              <el-table-column
                property="partAsh"
                label="段灰量(kg)"
                min-width="8.83%"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.partAsh | numfilters }}
                </template>
              </el-table-column>
              <el-table-column
                property="partCurrent"
                label="段电流(A)"
                min-width="8.83%"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.partCurrent | numfilters(1) }}
                </template>
              </el-table-column>
              <el-table-column
                property="partDensity"
                label="段密度(g/cm³)"
                min-width="10.5%"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.partDensity | numfilters(3) }}
                </template>
              </el-table-column>
              <el-table-column
                property="partDownSpeed"
                label="速度(cm/min)"
                min-width="9.83%"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.partDownSpeed | num3filters }}
                </template>
              </el-table-column>
              <el-table-column
                property="partPressure"
                label="段喷压(MPa)"
                min-width="9.83%"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.partPressure | numfilters(1) }}
                </template>
              </el-table-column>
              <el-table-column
                property="partTime"
                label="段时长(s)"
                min-width="8.83%"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="partDownSpeed"
                label="状态"
                min-width="4.66%"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.partDownSpeed | num5filters }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="m-tab-table m-tab-echartTable" v-show="tab2 === 1">
          <div id="echarts" class="m-pop-echart">
            <el-row class="row">
              <el-col :span="12" class="col">
                <div class="inner">
                  <div
                    ref="myChart01"
                    :style="{ width: '100%', height: '100%' }"
                  ></div>
                </div>
              </el-col>
              <el-col :span="12" class="col">
                <div class="inner">
                  <div
                    ref="myChart02"
                    :style="{ width: '100%', height: '100%' }"
                  ></div>
                </div>
              </el-col>
            </el-row>
            <el-row class="row">
              <el-col :span="12" class="col">
                <div class="inner">
                  <div
                    ref="myChart03"
                    :style="{ width: '100%', height: '100%' }"
                  ></div>
                </div>
              </el-col>
              <el-col :span="12" class="col">
                <div class="inner">
                  <div
                    ref="myChart04"
                    :style="{ width: '100%', height: '100%' }"
                  ></div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="echatrs" id="echartss">
            <div
              ref="myChart06"
              :style="{ width: '100%', height: '33.33%' }"
            ></div>
            <div
              ref="myChart07"
              :style="{ width: '100%', height: '33.33%' }"
            ></div>
            <div
              ref="myChart08"
              :style="{ width: '100%', height: '33.33%' }"
            ></div>
          </div>
        </div>
        <div class="m-tab-table" v-show="tab2 === 2">
          <el-row class="row">
            <el-col :span="12" class="col">
              <div class="inner inner1 backEchart">
                <div class="m-statusinfo">
                  <div class="top">
                    <h3>{{ selectItem.deviceTypeName }}</h3>
                    <div class="info">
                      <div class="item">
                        <div class="tit">桩号</div>
                        <div class="value">
                          {{ selectItem.pileDescribe }}
                        </div>
                      </div>
                      <div class="item">
                        <div class="tit">设备编号</div>
                        <div class="value">{{ selectItem.deviceKey }}</div>
                      </div>
                    </div>
                    <div class="status">
                      <ul class="ul-status">
                        <li :class="recordStatusClass">
                          <div class="btn">{{ pileDownStatus }}</div>
                        </li>
                        <li :class="pipeStatusClass">
                          <div class="btn">{{ pileStatusStr }}</div>
                        </li>
                        <li :class="nozzleStatusClass">
                          <div class="btn">{{ pulpStatus }}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="bottom">
                    <div class="item">
                      <h3>开始时间</h3>
                      <div class="value">
                        {{ selectItem.beginTime | datafilters }}
                      </div>
                    </div>
                    <div class="item">
                      <h3>水灰比</h3>
                      <div class="value">
                        {{ selectItem.waterCementRatio | numfilters }}
                      </div>
                    </div>
                    <div class="item">
                      <h3>密度</h3>
                      <div class="value">
                        {{ dataNum.partDensity | numfilters(3) }} g/cm³
                      </div>
                    </div>
                    <div class="item">
                      <h3>设计下钻速度</h3>
                      <div class="value">
                        {{ selectItem.designDownSpeed | numfilters(2) }} cm/min
                      </div>
                    </div>
                    <div class="item">
                      <h3>设计提钻速度</h3>
                      <div class="value">
                        {{ selectItem.designUpSpeed | numfilters(2) }} cm/min
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" class="col">
              <div class="inner backEchart">
                <div
                  ref="myChart05"
                  :style="{ width: '100%', height: '100%' }"
                ></div>
              </div>
            </el-col>
          </el-row>
          <el-row class="row">
            <el-col :span="12" class="col">
              <div class="m-box m-map" style="height: 27rem">
                <div class="con">
                  <div class="mapDiv" id="mapDiv"></div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" class="col">
              <div class="inner">
                <div class="m-datab1" style="height: 27rem">
                  <div class="top">
                    <div class="left">
                      <div class="icon" ref="angle" style=""></div>
                      <div class="t1">
                        <p>
                          X<b>{{ selectItem.xAngle | numfilters }}</b>
                        </p>
                        <p>
                          Y<b>{{ selectItem.yAngle | numfilters }}</b>
                        </p>
                      </div>
                    </div>
                    <div class="oh">
                      <div class="item">
                        <p class="item_center">持续时长(min)</p>
                        <b class="item_center">{{ LastTime | minfilters }}</b>
                      </div>
                      <div class="item">
                        <p class="item_center">累计浆量(L)</p>
                        <b class="item_center">{{
                          totalPartPulp | numfilters
                        }}</b>
                      </div>
                      <div class="item">
                        <p class="item_center">累计灰量(kg)</p>
                        <b class="item_center">{{
                          totalPartAsh | numfilters
                        }}</b>
                      </div>
                      <div class="item">
                        <p class="item_center">段浆量(L)</p>
                        <b class="item_center">{{
                          dataNum.partPulp | numfilters
                        }}</b>
                      </div>
                      <div class="item">
                        <p class="item_center">段灰量(kg)</p>
                        <b class="item_center">{{
                          dataNum.partAsh | numfilters
                        }}</b>
                      </div>
                    </div>
                  </div>
                  <div class="picbox">
                    <img src="../../assets/images/c-i3.png" class="bg" alt="" />
                    <div class="databar">
                      <div class="data" :style="{ bottom: ztTop }">
                        <img
                          src="../../assets/images/c-i5.png"
                          alt=""
                          :class="image"
                        />
                        <img
                          src="../../assets/images/c-i2.png"
                          alt=""
                          class="zt"
                        />
                        <div class="info">
                          <p>
                            <b>{{ pileStatusStr }}</b>
                          </p>
                          <p>
                            深度<em>{{ dataNum.partDeep | numfilters }}(m)</em>
                          </p>
                          <p>
                            速度<em
                              >{{
                                dataNum.partDownSpeed | numfilters
                              }}(cm/min)</em
                            >
                          </p>
                          <p>
                            电流<em
                              >{{ dataNum.partCurrent | numfilters }}(A)</em
                            >
                          </p>
                          <p>
                            流量<em
                              >{{
                                ((dataNum.partPulp / dataNum.partTime) * 60)
                                  | numfilters
                              }}(L/min)</em
                            >
                          </p>
                          <img
                            src="../../assets/images/c-i4.png"
                            alt=""
                            class="line"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="backplayBottom">
            <el-progress
              class="progress_bar"
              :show-text="false"
              :stroke-width="15"
              :percentage="percentage"
              :color="color"
            >
            </el-progress>
            <i class="iconBack el-icon-refresh-right" @click="stop"></i>
            <i class="iconBack" :class="icon" @click="backPlay"></i>
            <el-select
              class="selectspeed"
              size="small"
              v-model="value"
              @change="change"
              placeholder="正常"
            >
              <el-option
                class="selectspeedOpt"
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-footer class="m-selectAll">
      <div class="left" v-if="showDetail">
        <div class="item">
          <el-checkbox
            v-model="totalChecked"
            class="total"
            @change="totalChange"
          >
            全选
          </el-checkbox>
        </div>

        <div class="item">
          <div
            class="export"
            id="simulations"
            href=""
            @click="exportDialogVisible = true"
          >
            导出
          </div>
        </div>
      </div>
      <div class="right">
        <el-pagination
          class="pages"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="slot,prev, pager, next"
          :total="total"
        >
          <!-- slot部分，跳转首页 -->
          <button class="lastPage" @click="toFirstPage">
            <i class="el-icon-d-arrow-left"></i>
          </button>
        </el-pagination>
        <el-pagination
          class="pages"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="slot, jumper, sizes"
          :total="total"
        >
          <!-- slot部分，跳转末页 -->
          <button class="lastPage" @click="toLastPage">
            <i class="el-icon-d-arrow-right"></i>
          </button>
        </el-pagination>
      </div>
    </el-footer>

    <!-- 导出选择弹窗 -->
    <el-dialog
      title="选择导出方式"
      :visible.sync="exportDialogVisible"
      width="30%"
      center
      top="20vh"
    >
      <div class="export-dialog-buttons">
        <el-button
          type="primary"
          @click="exportStatistics"
          style="margin-bottom: 12px"
        >
          导出统计报表
        </el-button>
        <el-button type="primary" @click="exportConstructionRecord">
          导出施工记录表
        </el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tableToExcel from "../../utils/report";
import report from "../report/report.vue";
import moment from "moment";
import { historyList } from "@/api/api";
import gTabs from "@/components/gTabs";
import * as echarts from "echarts";
const allField = [
  "pileDescribe",
  "deviceKey",
  "beginTime",
  "endTime",
  "designDepth",
  "depth",
  "frDepth",
  "reDepth",
  "waterCementRatio",
  "cumulativePulp",
  "averagePulp",
  "cumulativeAsh",
  "averageAsh",
  "pileTopCurrent",
  "maxCurrent",
  "downSpeed",
  "upSpeed",
  "averageCurrent",
  "maxDownSpeed",
  "maxUpSpeed",
  "xAngle",
  "pileTime",
  "tTypeLength",
  "tTypePulp",
  "tTypeAsh",
  "bottomPartPulp",
  "bottomPartAsh",
  "emDepth",
]; //列表所有的数据
export default {
  components: {
    gTabs,
    report,
  },
  name: "carrousel",
  props: [
    "tableData",
    "device",
    "deviceList",
    "pageSize",
    "total",
    "currentPage",
    "handleSizeChange",
    "handleCurrentChange",
    "toLastPage",
    "toFirstPage",
  ],
  data() {
    return {
      // 回放数据
      options: [
        {
          value: "ordinary",
          label: "正常",
        },
        {
          value: "fast",
          label: "快速",
        },
        {
          value: "topspeed",
          label: "极速",
        },
      ],
      value: "ordinary",
      datalength: [],
      totalPartTime: 0,
      f: 0,
      t: 0,
      PlaybackTime: "",
      pileDeep: 0,
      icon: "el-icon-video-pause",
      // 段数据
      percentage: 0,
      color: "#000",
      playbackTimeDepth: [],
      playbackTimeFlow: [],
      LastTime: 0,
      totalPartPulp: 0,
      totalPartAsh: 0,
      ztTop: 100, //钻头位置
      pileStatusStr: "停钻",
      pileDownStatus: "结束",
      pulpStatus: "止喷",
      image: "stop",
      playBack: null,
      dingshi: null,
      y: 0.0, //钻头深度
      dataNum: [],
      recordStatusClass: "",
      pipeStatusClass: "",
      nozzleStatusClass: "",
      map: null,
      centerDialogVisible: false, // 弹窗
      // 回放数据
      pileDepth: "",
      pileDepth2: "",
      pileAsh: "",
      pileAsh2: "",
      pileTime: "",
      pileTime2: "",
      cumulativePileAsh: "",
      cumulativePileAsh2: "",
      // 更多条件按钮参数
      depthReport: [],
      pulpReport: {},
      ashReport: {},
      upspeed: {},
      downspeed: {},
      partcurrent: {},
      report: "report",
      checkedData: [],
      totalChecked: false,
      startDate: "",
      endDate: "",
      pileDescribe: "",
      deviceKey: "",
      checkedId: [], //存储点击后导出的id
      checkAll: false, //默认全选
      checkedFileds: [
        "pileDescribe",
        "deviceKey",
        "beginTime",
        "endTime",
        "designDepth",
        "depth",
        "pileTime",
        "cumulativePulp",
        "averageAsh",
        "cumulativeAsh",
        "downSpeed",
        "upSpeed",
        "pileTopCurrent",
      ], //默认显示选中的数据
      fieldNames: [
        {
          prop: "pileDescribe",
          label: "桩号",
        },
        {
          prop: "deviceKey",
          label: "设备编号",
        },
        {
          prop: "beginTime",
          label: "开始时间",
          formatter: this.testFormatter,
        },
        {
          prop: "endTime",
          label: "结束时间",
          formatter: this.testFormatter,
        },
        {
          prop: "designDepth",
          label: "设计桩长",
          formatter: this.designnumFormatter,
        },
        {
          prop: "depth",
          label: "施工桩长(m)",
          formatter: this.numFormatter,
        },
        {
          prop: "frDepth",
          label: "初搅深度(m)",
          formatter: this.numFormatter,
        },
        {
          prop: "reDepth",
          label: "复搅深度(m)",
          formatter: this.numFormatter,
        },
        {
          prop: "waterCementRatio",
          label: "水灰比(:1)",
          formatter: this.numFormatter,
        },
        {
          prop: "cumulativePulp",
          label: "累计浆量(L)",
          formatter: this.numsFormatter,
        },
        {
          prop: "averagePulp",
          label: "平均浆量(L/m)",
          formatter: this.numFormatter,
        },
        {
          prop: "cumulativeAsh",
          label: "累计灰量(kg)",
          formatter: this.numsFormatter,
        },
        {
          prop: "averageAsh",
          label: "平均灰量(kg/m)",
          formatter: this.numFormatter,
        },
        {
          prop: "pileTopCurrent",
          label: "桩端电流(A)",
          formatter: this.numsFormatter,
        },
        {
          prop: "maxCurrent",
          label: "最大电流(A)",
          formatter: this.numsFormatter,
        },
        {
          prop: "downSpeed",
          label: "下钻速度(cm/min)",
          formatter: this.numsFormatter,
        },
        {
          prop: "upSpeed",
          label: "提钻速度(cm/min)",
          formatter: this.numsFormatter,
        },
        {
          prop: "averageCurrent",
          label: "平均电流(A)",
          formatter: this.numFormatter,
        },
        {
          prop: "maxDownSpeed",
          label: "最大钻速(cm/min)",
          formatter: this.numsFormatter,
        },
        {
          prop: "maxUpSpeed",
          label: "最大提速(cm/min)",
          formatter: this.numsFormatter,
        },
        {
          prop: "xAngle",
          label: "最大斜度(%)",
          formatter: this.numsFormatter,
        },

        {
          prop: "pileTime",
          label: "成桩时间(min)	",
          formatter: this.minFormatter,
        },

        // {
        //   prop: "tTypeLength",
        //   label: "扩大头桩长(m)	",
        //   formatter: this.numFormatter,
        // },
        // {
        //   prop: "tTypePulp",
        //   label: "扩大头浆量(L)",
        //   formatter: this.numFormatter,
        // },
        // {
        //   prop: "tTypeAsh",
        //   label: "扩大头灰量(kg)",
        //   formatter: this.numFormatter,
        // },
        {
          prop: "bottomPartPulp",
          label: "下部桩浆量(L)",
          formatter: this.numsFormatter,
        },
        {
          prop: "bottomPartAsh",
          label: "下部桩灰量(kg)",
          formatter: this.numFormatter,
        },
        {
          prop: "emDepth",
          label: "空搅深度(m)",
          formatter: this.numFormatter,
        },
      ], //列表添加全部数据
      isIndeterminate: false, //默认全选
      dialogFormVisible: false,
      dialogFormVisibleMore: false, //更多条件弹框
      cols: [
        {
          prop: "pileDescribe",
          label: "桩号",
        },
        {
          prop: "deviceKey",
          label: "设备编号",
        },
        {
          prop: "beginTime",
          label: "开始时间",
          formatter: this.testFormatter,
        },
        {
          prop: "endTime",
          label: "结束时间",
          formatter: this.testFormatter,
        },
        {
          prop: "designDepth",
          label: "设计桩长",
          formatter: this.designnumFormatter,
        },
        {
          prop: "depth",
          label: "施工桩长(m)",
          formatter: this.numFormatter,
        },
        {
          prop: "cumulativePulp",
          label: "累计浆量(L)",
          formatter: this.numsFormatter,
        },
        {
          prop: "averageAsh",
          label: "平均灰量(kg/m)",
          formatter: this.numFormatter,
        },
        {
          prop: "cumulativeAsh",
          label: "累计灰量(kg)",
          formatter: this.numsFormatter,
        },
        {
          prop: "pileTopCurrent",
          label: "桩端电流(A)",
          formatter: this.numsFormatter,
        },
        {
          prop: "downSpeed",
          label: "下钻速度(cm/min)",
          formatter: this.numsFormatter,
        },
        {
          prop: "upSpeed",
          label: "提钻速度(cm/min)",
          formatter: this.numsFormatter,
        },
        // {
        //   prop: "averagePressure",
        //   label: "喷浆压力(Mpa)",
        //   formatter: this.numsFormatter,
        // },
        {
          prop: "pileTime",
          label: "成桩时间(min)",
          formatter: this.minFormatter,
        },
      ],
      tempCols: [], //临时的数据容器

      data: [],
      selectItem: [],
      tab2: 0,
      tab2List: [
        {
          name: "详细内容",
        },
        {
          name: "图表曲线",
        },
        {
          name: "历史回放",
        },
      ],
      firstDowntime: [],
      firstDowntime2: [],
      inquire: [],
      totalNum: 0,
      echartAll: [],
      echartsAll: [],
      show: false,
      showDetail: false,
      exportDialogVisible: false, // 导出选择弹窗
    };
  },
  filters: {
    datafilters(val) {
      return moment(val * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
    minfilters(val) {
      return (parseFloat(val) / 60).toFixed(2);
    },
    numfilters(val, deg) {
      if (deg == undefined) {
        deg = 2;
      }
      if (isNaN(val)) {
        //val 不是数字
        return val;
      } else {
        //val是数字
        return parseFloat(val).toFixed(deg);
      }
    },
    num3filters(val) {
      // return Math.abs(parseFloat(val).toFixed(2))
      return parseFloat(val).toFixed(2);
    },
    num5filters(val) {
      return val < 0 ? "提钻" : "下钻";
    },
  },
  watch: {
    centerDialogVisible(val, oldval) {
      window.onresize = null;
      if (val == false) {
        this.show = false;
        this.playBackClear();
        clearInterval(this.playBack);
        this.tab2 = 0;
        this.selectItem = [];
        this.data = [];
        this.upspeed = [];
        this.downspeed = [];
        this.ashReport = [];
        this.depthReport = [];
        this.partcurrent = [];
        if (this.myChart01 === undefined || this.myChart01._disposed) return;
        this.myChart01.dispose();
        this.myChart02.dispose();
        this.myChart03.dispose();
        this.myChart04.dispose();
        this.myChart06.dispose();
        this.myChart07.dispose();
        this.myChart08.dispose();
      }
    },
  },
  mounted() {
    if (sessionStorage["clientId"] == 39) {
      this.showDetail = true;

      this.cols.push({
        prop: "averagePressure",
        label: "喷浆压力(Mpa)",
        formatter: this.numsFormatter,
      });
    } else {
      this.showDetail = false;
    }
    sessionStorage["pileDepth"] = this.pileDepth;
    sessionStorage["cumulativePileAsh"] = this.cumulativePileAsh;
    sessionStorage["pileTime"] = this.pileTime;
    this.deviceKey = this.device;
  },
  methods: {
    // 图片下载
    download() {
      let a = document.createElement("a");
      a.href = this.myChart06.getConnectedDataURL({
        pixelRatio: 2,
        backgroundColor: "#fff",
      });
      a.download = "图片下载.png";
      a.click();
    },

    // 清除回放数据
    playBackClear() {
      this.value = "ordinary";
      this.datalength = [];
      this.totalPartTime = 0;
      this.f = 0;
      this.t = 0;
      this.PlaybackTime = "";
      this.pileDeep = 0;
      this.icon = "el-icon-video-pause";
      this.percentage = 0;
      this.playbackTimeDepth = [];
      this.playbackTimeFlow = [];
      this.LastTime = 0;
      this.totalPartPulp = 0;
      this.totalPartAsh = 0;
      this.ztTop = 100; //钻头位置
      this.pileStatusStr = "停钻";
      this.pileDownStatus = "结束";
      this.pulpStatus = "止喷";
      this.image = "stop";
      this.y = 0.0; //钻头深度
      this.dataNum = [];
      this.recordStatusClass = "";
      this.pipeStatusClass = "";
      this.nozzleStatusClass = "";
      clearInterval(this.playBack);
      clearInterval(this.dingshi);
      if (this.myChart05 === undefined || this.myChart05._disposed) return;
      this.myChart05.dispose();
    },
    // 设置table表格的宽度
    columnWidth(index) {
      // || index == 10 || index == 11 || index == 12 || index == 13 || index == 14
      if (
        index == 4 ||
        index == 5 ||
        index == 6 ||
        index == 7 ||
        index == 8 ||
        index == 9
      ) {
        return 120;
      }
      if (index == 10 || index == 11 || index == 12) {
        return 150;
      }
    },
    exportAll() {
      // 历史页面导出按钮（保留原方法，供其他调用）
      tableToExcel("statisticsTableRecord", "-搅拌桩-统计报表");
      // window.open(http + '/exportSelect?ids=' + this.checkedId.join())
    },
    // 导出选择弹窗 - 导出统计报表
    exportStatistics() {
      this.exportDialogVisible = false;
      tableToExcel("statisticsTableRecord", "-搅拌桩-统计报表");
    },
    // 导出选择弹窗 - 导出施工记录表
    exportConstructionRecord() {
      this.exportDialogVisible = false;
      tableToExcel("TBLTableRecord", "-搅拌桩-施工记录表");
    },
    // 报表下载
    downLoad(command) {
      switch (command) {
        case 0: {
          // window.open(http + "/downloadExcel2Print?id=" + this.selectItem._id)
          tableToExcel(
            "statisticsTablePrint",
            moment(this.selectItem.beginTime * 1000).format("YYYY-MM-DD") +
              "-搅拌桩-打印版"
          );
          break;
        }
        case 1: {
          tableToExcel(
            "statisticsTable",
            moment(this.selectItem.beginTime * 1000).format("YYYY-MM-DD") +
              "-搅拌桩-综合版"
          );
          break;
        }
        case 2: {
          tableToExcel(
            "statisticsTabledetailed",
            moment(this.selectItem.beginTime * 1000).format("YYYY-MM-DD") +
              "-搅拌桩_详细版"
          );
          break;
        }
      }
    },
    // 设备查询
    querychxun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      //选择设备查询
      //将修改的key值传到主页面
      //在主页面改为传过来的值
      //主页写接受参数的方法
      historyList(
        "JBZ",
        0,
        this.deviceKey,
        this.pageSize,
        this.pileDescribe,
        this.startDate,
        this.endDate
      ).then((res) => {
        // this.tableData = res.content;
        // this.total = res.totalElements;
        this.inquire = res.content;
        this.totalNum = res.totalElements;
        this.$emit(
          "changeDevicekey",
          this.deviceKey,
          this.pileDescribe,
          this.startDate,
          this.endDate,
          this.inquire,
          this.totalNum
        );
        loading.close();
      });
      setTimeout(() => {
        loading.close();
      }, 6000);
    },
    // 重置按钮
    resetClick() {
      this.deviceKey = "";
      this.pileDescribe = "";
      this.startDate = "";
      this.endDate = "";
    },
    testFormatter(row, column, cellValue, index) {
      return moment(cellValue * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
    minFormatter(row, column, cellValue, index) {
      return (parseFloat(cellValue) / 60).toFixed(0);
    },
    numFormatter(row, column, cellValue, index) {
      return parseFloat(cellValue).toFixed(2);
    },
    numsFormatter(row, column, cellValue, index) {
      return parseFloat(cellValue).toFixed(1);
    },
    designnumFormatter(row, column, cellValue, index) {
      if (cellValue == undefined) {
        return "--";
      } else {
        return parseFloat(cellValue).toFixed(2);
      }
    },
    //全选按钮 选择参数显示数据
    handleCheckAllChange(val) {
      this.checkedFileds = val ? allField : [];
      this.isIndeterminate = false;
    },
    //单个选中
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.fieldNames.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.fieldNames.length;
    },
    // 更多条件弹出框
    moreConditions() {
      this.dialogFormVisibleMore = true;
    },
    // 更多条件确定按钮
    moreDetermine() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      historyList(
        "JBZ",
        0,
        this.device,
        this.pageSize,
        this.pileDescribe,
        this.startDate,
        this.endDate,
        this.pileDepth,
        this.cumulativePileAsh,
        this.pileTime,
        this.pileDepth2,
        this.pileAsh,
        this.pileAsh2,
        this.cumulativePileAsh2,
        this.pileTime2
      ).then((res) => {
        this.inquire = res.content;
        this.totalNum = res.totalElements;
        this.$emit(
          "changeDevicekey",
          this.device,
          this.pileDescribe,
          this.startDate,
          this.endDate,
          this.inquire,
          this.totalNum,
          this.pileDepth2,
          this.pileAsh,
          this.pileAsh2,
          this.cumulativePileAsh2,
          this.pileTime2,
          this.pileDepth,
          this.pileTime,
          this.cumulativePileAsh
        );
        loading.close();
      });
      this.dialogFormVisibleMore = false;
    },
    confirmShow() {
      this.tempCols = [];
      if (this.checkedFileds.length < 1) {
        this.$message.warning("请至少选择一项数据");
        this.dialogFormVisible = true;
      } else {
        for (var i = 0; i < this.fieldNames.length; i++) {
          for (var j = 0; j < this.checkedFileds.length; j++) {
            if (this.fieldNames[i].prop == this.checkedFileds[j]) {
              this.tempCols.push(this.fieldNames[i]);
            }
          }
        }
        this.cols = this.tempCols;
        this.dialogFormVisible = false;
      }
    },
    initechart06() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.partDeep];
      });
      let y2Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.partDensity.toFixed(3) + ""];
      });
      let option = {
        title: {
          text: "深度、密度曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["深度", "密度"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },

        xAxis: {
          type: "time",
          axisLabel: {
            interval: 10,
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "深度(m)  ",
            type: "value",
            inverse: true,
            nameLocation: "end",
            axisLine: {
              //设置轴线
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
          },
          {
            name: " 密度(g/cm³)",
            nameLocation: "end", // 设置坐标轴名称显示位置
            inverse: true,
            type: "value",
            splitLine: {
              //网格不显示
              show: false,
            },
            nameTextStyle: {
              padding: [10, 20, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "深度",
            type: "line",
            showSymbol: false,
            data: y1Data,
            animation: false,
          },
          {
            name: "密度",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: y2Data,
            animation: false,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart06 = echarts.init(this.$refs.myChart06, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart06.setOption(option);

      this.echartsAll.push(this.myChart06);
    },
    initechart07() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.partDeep];
      });
      let y2Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.partCurrent.toFixed(2)];
      });
      let option = {
        title: {
          text: "深度、电流曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["深度", "电流"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        xAxis: {
          type: "time",
          axisLabel: {
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "深度(m)       ",
            type: "value",
            inverse: true, //设置坐标轴翻转
            nameLocation: "end",
            axisLine: {
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
          },
          {
            name: "      电流(A)",
            type: "value",
            nameLocation: "start",
            splitLine: {
              show: false,
            },
            nameTextStyle: {
              padding: [10, 15, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "深度",
            type: "line",
            showSymbol: false,
            data: y1Data,
            animation: false,
          },
          {
            name: "电流",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: y2Data,
            animation: false,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart07 = echarts.init(this.$refs.myChart07, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart07.setOption(option);

      this.echartsAll.push(this.myChart07);
    },
    initechart08() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], ((item.partPulp / item.partTime) * 60).toFixed(2)];
      });
      let y2Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.partDownSpeed.toFixed(2)];
      });
      let option = {
        title: {
          text: "流量、速度曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["流量", "速度"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        xAxis: {
          type: "time",
          axisLabel: {
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "流量(L/min)",
            type: "value",
            nameLocation: "start",
            axisLine: {
              //设置坐标轴是否显示
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
            max: 150,
            min: 0,
          },
          {
            name: "速度(cm/min)      ",
            type: "value",
            nameLocation: "start",
            splitLine: {
              //网格线
              show: false,
            },
            nameTextStyle: {
              padding: [10, 15, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "流量",
            type: "line",
            showSymbol: false,
            data: y1Data,
            animation: false,
          },
          {
            name: "速度",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: y2Data,
            animation: false,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      // this.myChart03 = echarts.init(this.$refs.myChart03, null, { renderer: 'svg' });
      this.myChart08 = echarts.init(this.$refs.myChart08, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart08.setOption(option);

      this.echartsAll.push(this.myChart08);
    },
    initEchart01() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.partDeep];
      });
      let y2Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.partDensity.toFixed(3) + ""];
      });
      let option = {
        title: {
          text: "深度、密度曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["深度", "密度"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: "3%",
          feature: {
            saveAsImage: {
              type: "png",
            },
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            interval: 10,
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "深度(m)  ",
            type: "value",
            inverse: true,
            nameLocation: "end",
            axisLine: {
              //设置轴线
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
          },
          {
            name: " 密度(g/cm³)",
            nameLocation: "end", // 设置坐标轴名称显示位置
            inverse: true,
            type: "value",
            splitLine: {
              //网格不显示
              show: false,
            },
            nameTextStyle: {
              padding: [10, 20, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "深度",
            type: "line",
            showSymbol: false,
            data: y1Data,
          },
          {
            name: "密度",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: y2Data,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart01 = echarts.init(this.$refs.myChart01, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart01.setOption(option);

      this.echartAll.push(this.myChart01);
    },
    initEchart02() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.partDeep];
      });
      let y2Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.partCurrent.toFixed(2)];
      });
      let option = {
        title: {
          text: "深度、电流曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["深度", "电流"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: "3%",
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "深度(m)       ",
            type: "value",
            inverse: true, //设置坐标轴翻转
            nameLocation: "end",
            axisLine: {
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
          },
          {
            name: "      电流(A)",
            type: "value",
            nameLocation: "start",
            splitLine: {
              show: false,
            },
            nameTextStyle: {
              padding: [10, 15, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "深度",
            type: "line",
            showSymbol: false,
            data: y1Data,
          },
          {
            name: "电流",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: y2Data,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart02 = echarts.init(this.$refs.myChart02, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart02.setOption(option);

      this.echartAll.push(this.myChart02);
    },
    initEchart03() {
      let data = this.data;
      let y1Data = this.selectItem.data.map((item, index) => {
        return [data[index], ((item.partPulp / item.partTime) * 60).toFixed(2)];
      });
      let y2Data = this.selectItem.data.map((item, index) => {
        return [data[index], item.partDownSpeed.toFixed(2)];
      });
      let option = {
        title: {
          text: "流量、速度曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["流量", "速度"],
        },
        grid: {
          top: "23%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: "3%",
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "流量(L/min)",
            type: "value",
            nameLocation: "start",
            axisLine: {
              //设置坐标轴是否显示
              show: true,
            },
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
            max: 150,
            min: 0,
          },
          {
            name: "速度(cm/min)      ",
            type: "value",
            nameLocation: "start",
            splitLine: {
              //网格线
              show: false,
            },
            nameTextStyle: {
              padding: [10, 15, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "流量",
            type: "line",
            showSymbol: false,
            data: y1Data,
          },
          {
            name: "速度",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: y2Data,
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      // this.myChart03 = echarts.init(this.$refs.myChart03, null, { renderer: 'svg' });
      this.myChart03 = echarts.init(this.$refs.myChart03, null, {
        devicePixelRatio: 2.5,
      });
      // 绘制图表
      this.myChart03.setOption(option);

      this.echartAll.push(this.myChart03);
    },
    initEchart04() {
      var ash = [];
      for (var j = 0; j < this.selectItem.data.length; j++) {
        if (ash[Math.ceil(this.selectItem.data[j].partDeep - 1)] == undefined) {
          ash[Math.ceil(this.selectItem.data[j].partDeep - 1)] = 0;
        }
        ash[Math.ceil(this.selectItem.data[j].partDeep - 1)] +=
          this.selectItem.data[j].partAsh;
      }
      var numbers2 = ash.map(myFunction);
      function myFunction(value, index, array) {
        var data = {
          value: Number(value.toFixed(2)),
          name: index + 1,
        };
        return data;
      }
      let option = {
        title: {
          text: "成桩灰量分布",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} : {c}Kg",
        },
        grid: {
          top: "10%",
          bottom: "10%",
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        series: [
          {
            name: "灰量分布",
            type: "funnel",
            width: "50%",
            left: "center",
            top: "15%",
            bottom: "8%",
            label: {
              show: true,
            },
            labelLine: {
              show: true,
            },
            data: numbers2,
            sort: "none",
            color: "#5470c6",
          },
        ],
      };
      // 基于准备好的dom，初始化echarts实例
      this.myChart04 = echarts.init(this.$refs.myChart04, null, {
        renderer: "svg",
      });
      // 绘制图表
      this.myChart04.setOption(option);
    },
    initEchart05() {
      let option = {
        title: {
          text: "深度、流量曲线",
          textStyle: {
            color: "#101D34",
            fontSize: 16,
          },
          left: "2.2%",
          top: "5%",
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: "5%",
          right: "10%",
          data: ["深度", "流量"],
        },
        grid: {
          top: "15%",
          left: "3%",
          right: "3%",
          bottom: "13%",
          containLabel: true,
        },
        toolbox: {
          right: "3%",
          top: "3%",
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            interval: 10,
            formatter: "{HH}:{mm}",
          },
        },
        yAxis: [
          {
            name: "深度(m)  ",
            type: "value",
            inverse: true,
            nameLocation: "end",
            axisLine: {
              //设置轴线
              show: true,
            },
            max: 30,
            nameTextStyle: {
              padding: [10, 0, 0, 15],
            },
          },
          {
            name: " 流量(L/min)",
            nameLocation: "start", // 设置坐标轴名称显示位置
            // inverse: true,
            type: "value",
            splitLine: {
              //网格不显示
              show: false,
            },
            max: 120,
            min: 0,
            nameTextStyle: {
              padding: [10, 20, 0, 0],
            },
          },
        ],
        series: [
          {
            name: "深度",
            type: "line",
            showSymbol: false,
            data: this.playbackTimeDepth,
          },
          {
            name: "流量",
            yAxisIndex: 1,
            type: "line",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            showSymbol: false,
            data: this.playbackTimeFlow,
          },
        ],
      };

      // 绘制图表
      this.myChart05.setOption(option);
    },
    // 倾角
    setAngle(xAngle, yAngle) {
      let angleOption = {
        tooltip: {
          show: false,
          trigger: "axis",
          formatter: "x: " + xAngle + "<br />y :" + yAngle,
        },
        grid: {
          left: "0",
          top: "0",
          right: "0",
          bottom: "0",
        },
        xAxis: {
          type: "value",
          min: "-20",
          max: "20",
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          min: "-20",
          max: "20",
          axisLabel: {
            show: false,
          },
        },
        series: [
          {
            symbolSize: 10,
            data: [[xAngle, yAngle]],
            type: "scatter",
          },
        ],
      };
      if (this.angle == undefined) {
        this.angle = echarts.init(this.$refs.angle);
      }
      this.angle.setOption(angleOption);
    },
    // 历史详情弹出框头部标签点击切换
    changeHandle(index) {
      let self = this;
      this.tab2 = index;
      if (index === 0) {
        this.show = false;
        this.playBackClear();
      }
      if (index === 1) {
        this.show = true;
        this.$nextTick(() => {
          this.initechart06();
          this.initechart07();
          this.initechart08();
          echarts.connect(this.echartsAll);
          this.initEchart04();
          this.initEchart01(), this.initEchart02(), this.initEchart03();
          // 图表实例实现联动
          echarts.connect(this.echartAll);
          window.onresize = function () {
            self.myChart01.resize();
            self.myChart02.resize();
            self.myChart03.resize();
            self.myChart04.resize();
          };
        });
        this.playBackClear();
      }
      if (index === 2) {
        this.show = false;
        this.$nextTick(() => {
          this.loadmap();
          // 基于准备好的dom，初始化echarts实例
          this.myChart05 = echarts.init(this.$refs.myChart05, null, {
            renderer: "svg",
          });
          this.initEchart05();
          window.onresize = function () {
            self.myChart05.resize();
            self.map.checkResize();
          };
        });
        if (this.selectItem.xAngle == undefined) {
          this.selectItem.xAngle = 0;
        }
        if (this.selectItem.yAngle == undefined) {
          this.selectItem.yAngle = 0;
        }
        this.setAngle(this.selectItem.xAngle, this.selectItem.yAngle);
        // 设置回放
        this.datalength = this.selectItem.data;
        for (let i = 0; i < this.datalength.length; i++) {
          this.totalPartTime += this.datalength[i].partTime;
        }
        this.PlaybackTime = this.selectItem.beginTime;
        this.playbackTimeDepth.push([
          moment(this.PlaybackTime * 1000).format("YYYY-MM-DD HH:mm:ss"),
          0,
        ]);
        this.playbackTimeFlow.push([
          moment(this.PlaybackTime * 1000).format("YYYY-MM-DD HH:mm:ss"),
          0,
        ]);
        this.dingshi = setInterval(() => {
          this.dataHistoryBack2();
        }, 3000);
        this.playBack = setInterval(() => {
          this.dataHistoryBack();
        }, 3000);
      }
    },
    dataHistoryBack() {
      this.percentage = Number(
        ((this.LastTime / this.totalPartTime) * 100).toFixed(1)
      );
      this.pileDownStatus = "开始";
      this.recordStatusClass = "on";
      this.myFun(this.datalength[this.f++].partDeep);
      if (this.f == this.datalength.length) {
        this.percentage = 100;
        this.pileDownStatus = "结束";
        this.icon = "el-icon-video-play";
        this.recordStatusClass = "";
        clearInterval(this.playBack);
      }
    },
    dataHistoryBack2() {
      this.dataNum = this.datalength[this.t++];
      this.PlaybackTime += this.dataNum.partTime;
      this.playbackTimeDepth.push([
        moment(this.PlaybackTime * 1000).format("YYYY-MM-DD HH:mm:ss"),
        this.dataNum.partDeep,
      ]);
      this.playbackTimeFlow.push([
        moment(this.PlaybackTime * 1000).format("YYYY-MM-DD HH:mm:ss"),
        ((this.dataNum.partPulp / this.dataNum.partTime) * 60).toFixed(2),
      ]);
      this.LastTime += this.dataNum.partTime;
      this.totalPartPulp += this.dataNum.partPulp;
      this.totalPartAsh += this.dataNum.partAsh;
      if (this.pileDeep < this.dataNum.partDeep) {
        this.pileStatusStr = "下钻";
        this.image = "down";
        this.pulpStatus = "喷浆";
      } else {
        this.pileStatusStr = "提钻";
        this.image = "up";
        this.pulpStatus = "止喷";
      }
      this.pileDeep = this.dataNum.partDeep;
      this.pipeStatusClass = "on";
      this.nozzleStatusClass = "on";
      this.initEchart05();
      if (this.t == this.datalength.length) {
        this.pipeStatusClass = "";
        this.nozzleStatusClass = "";
        this.pileStatusStr = "停钻";
        this.image = "stop";
        this.pulpStatus = "止喷";
        clearInterval(this.dingshi);
      }
    },
    // 回放速度切换
    change() {
      if (this.pileDownStatus == "结束") {
        return;
      } else {
        if (this.value == "fast") {
          clearInterval(this.playBack);
          clearInterval(this.dingshi);
          this.dingshi = setInterval(() => {
            this.dataHistoryBack2();
          }, 2000);
          this.playBack = setInterval(() => {
            this.dataHistoryBack();
          }, 2000);
        } else if (this.value == "topspeed") {
          clearInterval(this.playBack);
          clearInterval(this.dingshi);
          this.dingshi = setInterval(() => {
            this.dataHistoryBack2();
          }, 1000);
          this.playBack = setInterval(() => {
            this.dataHistoryBack();
          }, 1000);
        } else if (this.value == "ordinary") {
          clearInterval(this.playBack);
          clearInterval(this.dingshi);
          this.dingshi = setInterval(() => {
            this.dataHistoryBack2();
          }, 3000);
          this.playBack = setInterval(() => {
            this.dataHistoryBack();
          }, 3000);
        }
      }
    },
    // 历史回放暂停，开始切换
    backPlay() {
      if (this.icon == "el-icon-video-pause") {
        clearInterval(this.playBack);
        clearInterval(this.dingshi);
        this.icon = "el-icon-video-play";
      } else if (this.icon == "el-icon-video-play") {
        if (this.pileDownStatus == "结束") {
          this.value = "ordinary";
          this.f = 0;
          this.t = 0;
          this.playbackTimeDepth = [];
          this.playbackTimeFlow = [];
          this.LastTime = 0;
          this.totalPartPulp = 0;
          this.totalPartAsh = 0;
          this.ztTop = 100; //钻头位置
          this.pileStatusStr = "停钻";
          this.pileDownStatus = "结束";
          this.pulpStatus = "止喷";
          this.image = "stop";
          this.y = 0.0; //钻头深度
          this.dataNum = [];
          this.recordStatusClass = "";
          this.pipeStatusClass = "";
          this.nozzleStatusClass = "";
          clearInterval(this.playBack);
          clearInterval(this.dingshi);
          this.dingshi = setInterval(() => {
            this.dataHistoryBack2();
          }, 3000);
          this.playBack = setInterval(() => {
            this.dataHistoryBack();
          }, 3000);
        } else {
          let T = 3000;
          if (this.value == "ordinary") {
            T = 3000;
          } else if (this.value == "fast") {
            T = 2000;
          } else if (this.value == "topspeed") {
            T = 1000;
          }
          this.dingshi = setInterval(() => {
            this.dataHistoryBack2();
          }, T);
          this.playBack = setInterval(() => {
            this.dataHistoryBack();
          }, T);
        }
        this.icon = "el-icon-video-pause";
      }
    },
    // 重置回放进度
    stop() {
      this.value = "ordinary";
      this.f = 0;
      this.t = 0;
      this.playbackTimeDepth = [];
      this.playbackTimeFlow = [];
      this.LastTime = 0;
      this.totalPartPulp = 0;
      this.totalPartAsh = 0;
      this.ztTop = 100; //钻头位置
      this.pileStatusStr = "停钻";
      this.pileDownStatus = "结束";
      this.pulpStatus = "止喷";
      this.image = "stop";
      this.y = 0.0; //钻头深度
      this.dataNum = [];
      this.recordStatusClass = "";
      this.pipeStatusClass = "";
      this.nozzleStatusClass = "";
      clearInterval(this.playBack);
      clearInterval(this.dingshi);

      this.dingshi = setInterval(() => {
        this.dataHistoryBack2();
      }, 3000);
      this.playBack = setInterval(() => {
        this.dataHistoryBack();
      }, 3000);
    },
    // 点击详情 详情弹出框
    handleCommand(index) {
      this.selectItem = this.tableData[index];
      // 显示弹出框
      this.centerDialogVisible = true;
      var day = this.selectItem.beginTime;
      var time;
      var pulp25 = [];
      var pulp50 = [];
      var pulp75 = [];
      var pulp100 = [];
      var num = [];
      var current = [];
      // var initialdeep = 0
      let map = new Map();
      let maps = new Map();
      for (var i = 0; i < this.tableData[index].data.length; i++) {
        day += this.tableData[index].data[i].partTime;
        time = moment(day * 1000).format("YYYY-MM-DD HH:mm:ss");
        this.data.push(time);
        if (this.tableData[index].data[i].partDeep != 0) {
          this.depthReport.push(
            Math.ceil(this.tableData[index].data[i].partDeep)
          );
        }
        // 数组去重
        for (var k = 0; k < this.depthReport.length; k++) {
          for (var j = k + 1; j < this.depthReport.length; j++) {
            if (this.depthReport[k] == this.depthReport[j]) {
              //第一个等同于第二个，splice方法删除第二个
              this.depthReport.splice(j, 1);
              j--;
            }
          }
        }
        if (
          this.tableData[index].data[i].partDeep ==
          Math.floor(this.tableData[index].data[i].partDeep) + 0.25
        ) {
          let obj = {
            key: Math.floor(this.tableData[index].data[i].partDeep) + 0.25,
            value: Number(this.tableData[index].data[i].partPulp),
          };
          pulp25.push(obj);
          var result = {};
          pulp25.forEach((item) => {
            if (result[item.key]) {
              result[item.key] += item.value;
            } else {
              result[item.key] = item.value;
            }
          });
        }
        if (
          this.tableData[index].data[i].partDeep ==
          Math.floor(this.tableData[index].data[i].partDeep) + 0.5
        ) {
          let obj1 = {
            key: Math.floor(this.tableData[index].data[i].partDeep) + 0.5,
            value: Number(this.tableData[index].data[i].partPulp.toFixed(2)),
          };
          pulp50.push(obj1);
          var results = {};
          pulp50.forEach((item) => {
            if (results[item.key]) {
              results[item.key] += item.value;
            } else {
              results[item.key] = item.value;
            }
          });
        }
        if (
          this.tableData[index].data[i].partDeep ==
          Math.floor(this.tableData[index].data[i].partDeep) + 0.75
        ) {
          let obj2 = {
            key: Math.floor(this.tableData[index].data[i].partDeep) + 0.75,
            value: Number(this.tableData[index].data[i].partPulp.toFixed(2)),
          };
          pulp75.push(obj2);
          var resultss = {};
          pulp75.forEach((item) => {
            if (resultss[item.key]) {
              resultss[item.key] += item.value;
            } else {
              resultss[item.key] = item.value;
            }
          });
        }
        if (
          this.tableData[index].data[i].partDeep ==
          Math.floor(this.tableData[index].data[i].partDeep)
        ) {
          let obj3 = {
            key: Math.floor(this.tableData[index].data[i].partDeep),
            value: Number(this.tableData[index].data[i].partPulp.toFixed(2)),
          };
          pulp100.push(obj3);
          var result100 = {};
          pulp100.forEach((item) => {
            if (result100[item.key]) {
              result100[item.key] += item.value;
            } else {
              result100[item.key] = item.value;
            }
          });
        }
        // 段灰量数据
        if (
          num[Math.ceil(this.tableData[index].data[i].partDeep - 1)] ==
          undefined
        ) {
          num[Math.ceil(this.tableData[index].data[i].partDeep - 1)] = 0;
        }
        num[Math.ceil(this.tableData[index].data[i].partDeep - 1)] += Number(
          this.tableData[index].data[i].partAsh.toFixed(2)
        );
        // 段电流数据
        if (
          current[Math.ceil(this.tableData[index].data[i].partDeep - 1)] ==
          undefined
        ) {
          current[Math.ceil(this.tableData[index].data[i].partDeep - 1)] = 0;
        }
        current[Math.ceil(this.tableData[index].data[i].partDeep - 1)] = Number(
          this.tableData[index].data[i].partCurrent.toFixed(2)
        );
        // 下钻速度
        if (
          this.tableData[index].data[i].partDeep > 0 &&
          this.tableData[index].data[i].partDownSpeed > 0
        ) {
          if (
            map.get(Math.ceil(this.tableData[index].data[i].partDeep)) ==
            undefined
          ) {
            let deeep = [];
            deeep.push(this.tableData[index].data[i].partDownSpeed);
            map.set(Math.ceil(this.tableData[index].data[i].partDeep), deeep);
          } else {
            let deeep = map.get(
              Math.ceil(this.tableData[index].data[i].partDeep)
            );
            deeep.push(this.tableData[index].data[i].partDownSpeed);
            map.set(Math.ceil(this.tableData[index].data[i].partDeep), deeep);
          }
        }
        // 提钻
        if (this.tableData[index].data[i].partDownSpeed < 0) {
          if (
            maps.get(Math.ceil(this.tableData[index].data[i].partDeep)) ==
            undefined
          ) {
            let deeep = [];
            deeep.push(this.tableData[index].data[i].partDownSpeed);
            maps.set(Math.ceil(this.tableData[index].data[i].partDeep), deeep);
          } else {
            let deeep = maps.get(
              Math.ceil(this.tableData[index].data[i].partDeep)
            );
            deeep.push(this.tableData[index].data[i].partDownSpeed);
            maps.set(Math.ceil(this.tableData[index].data[i].partDeep), deeep);
          }
        }
      }
      var currents = [];
      for (let a = 0; a < current.length; a++) {
        let obj = {
          key: a,
          value: current[a],
        };
        currents.push(obj);
      }
      currents.forEach((item) => {
        if (this.partcurrent[item.key]) {
          this.partcurrent[item.key] += item.value;
        } else {
          this.partcurrent[item.key] = item.value;
        }
      });
      // 提钻速度
      var upspeed = [];
      maps.forEach(function (key) {
        upspeed.push(key);
      });
      var averageupSpeed = [];
      var upnum = 0;
      for (let a = 0; a < upspeed.length; a++) {
        for (let s = 0; s < upspeed[a].length; s++) {
          upnum += upspeed[a][s];
        }
        let averageup = Math.abs((upnum / upspeed[a].length).toFixed(2));
        averageupSpeed.push(averageup);
        upnum = 0;
      }
      averageupSpeed = averageupSpeed.reverse();
      var up = [];
      for (let a = 0; a < averageupSpeed.length; a++) {
        let obj = {
          key: a,
          value: averageupSpeed[a],
        };
        up.push(obj);
      }
      up.forEach((item) => {
        if (this.upspeed[item.key]) {
          this.upspeed[item.key] += item.value;
        } else {
          this.upspeed[item.key] = item.value;
        }
      });
      // 下钻速度
      var downdeep = [];
      map.forEach(function (key) {
        downdeep.push(key);
      });
      var averagedownSpeed = [];
      var nums = 0;
      for (let a = 0; a < downdeep.length; a++) {
        for (let s = 0; s < downdeep[a].length; s++) {
          nums += downdeep[a][s];
        }
        let average = Number((nums / downdeep[a].length).toFixed(2));
        averagedownSpeed.push(average);
        nums = 0;
      }
      var down = [];
      for (let a = 0; a < averagedownSpeed.length; a++) {
        let obj = {
          key: a,
          value: averagedownSpeed[a],
        };
        down.push(obj);
      }
      down.forEach((item) => {
        if (this.downspeed[item.key]) {
          this.downspeed[item.key] += item.value;
        } else {
          this.downspeed[item.key] = item.value;
        }
      });
      // 段灰量
      var ash = [];
      for (let k = 0; k < num.length; k++) {
        let obj = {
          key: k,
          value: num[k],
        };
        ash.push(obj);
      }
      ash.forEach((item) => {
        if (this.ashReport[item.key]) {
          this.ashReport[item.key] += item.value;
        } else {
          this.ashReport[item.key] = item.value;
        }
      });
      this.depthReport.unshift(0);
      this.depthReport.splice(this.depthReport.length - 1, 1);
      this.pulpReport = Object.assign(result, results, resultss, result100);
    },
    // 历史页面全选选择框 全选列表导出
    selectionChange(e) {
      this.checkedData = e.reverse();
      var data = [];
      for (let i = 0; i < e.length; i++) {
        data.push(e[i].data);
      }
      var firstdown = [];
      var firstDownspeed = []; //所有的下钻
      var firstupSpeed = []; //所有的提钻
      var firstup = [];
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].length; j++) {
          if (data[i][j].partDownSpeed > 0) {
            firstdown.push([
              data[i][j].partDeep,
              data[i][j].partTime,
              data[i][j].partDownSpeed,
            ]);
          }
          if (data[i][j].partDownSpeed < 0) {
            firstup.push([
              data[i][j].partDeep,
              data[i][j].partTime,
              data[i][j].partDownSpeed,
            ]);
          }
        }
        firstDownspeed.push(firstdown);
        firstupSpeed.push(firstup);
        firstup = [];
        firstdown = [];
      }
      var a = [];
      for (let i = 0; i < firstDownspeed.length; i++) {
        for (let k = 1; k < firstDownspeed[i].length; k++) {
          if (firstDownspeed[i][k - 1][0] > firstDownspeed[i][k][0]) {
            var d = k;
          }
        }
        if (d == 0 || d == undefined) {
          d = firstDownspeed[i].length;
        }
        a.push(d);
        d = 0;
      }
      var speedone = []; //第一次下钻
      var speedtwo = []; //第二次下钻
      for (let j = 0; j < firstDownspeed.length; j++) {
        speedone.push(firstDownspeed[j].slice(0, a[j]));
        speedtwo.push(firstDownspeed[j].slice(a[j]));
      }
      // 第一次下钻速度
      var time1 = 0;
      var total1 = 0;
      for (let i = 0; i < speedone.length; i++) {
        for (let j = 0; j < speedone[i].length; j++) {
          time1 += speedone[i][j][1];
          total1 += speedone[i][j][1] * speedone[i][j][2];
        }
        if (total1 / time1 == "Infinity" || speedone[i].length == 0) {
          this.checkedData[i].speed1 = 0;
        } else {
          this.checkedData[i].speed1 = (total1 / time1).toFixed(2);
        }
        time1 = 0;
        total1 = 0;
      }
      // 第二次下钻速度
      var time2 = 0;
      var total2 = 0;
      for (let i = 0; i < speedtwo.length; i++) {
        for (let j = 0; j < speedtwo[i].length; j++) {
          time2 += speedtwo[i][j][1];
          total2 += speedtwo[i][j][1] * speedtwo[i][j][2];
        }
        if (total2 / time2 == "Infinity" || speedtwo[i].length == 0) {
          this.checkedData[i].speed2 = 0;
        } else {
          this.checkedData[i].speed2 = (total2 / time2).toFixed(2);
        }
        time2 = 0;
        total2 = 0;
      }
      // 提钻速度
      var b = [];
      for (let i = 0; i < firstupSpeed.length; i++) {
        for (let k = 1; k < firstupSpeed[i].length; k++) {
          if (firstupSpeed[i][k - 1][0] < firstupSpeed[i][k][0]) {
            var up = k;
          }
        }
        if (up == 0 || up == undefined) {
          up = firstupSpeed[i].length;
        }
        b.push(up);
        up = 0;
      }
      var speedUpone = []; //第一次提钻
      var speedUptwo = []; //第二次提钻
      for (let j = 0; j < firstupSpeed.length; j++) {
        speedUpone.push(firstupSpeed[j].slice(0, b[j]));
        speedUptwo.push(firstupSpeed[j].slice(b[j]));
      }
      // 第一次提钻速度
      var time3 = 0;
      var total3 = 0;
      for (let i = 0; i < speedUpone.length; i++) {
        for (let j = 0; j < speedUpone[i].length; j++) {
          time3 += speedUpone[i][j][1];
          total3 += speedUpone[i][j][1] * speedUpone[i][j][2];
        }
        if (total3 / time3 == "Infinity" || speedUpone[i].length == 0) {
          this.checkedData[i].speed3 = 0;
        } else {
          this.checkedData[i].speed3 = Math.abs((total3 / time3).toFixed(2));
        }
        time3 = 0;
        total3 = 0;
      }
      // 第二次提钻速度
      var time4 = 0;
      var total4 = 0;
      for (let i = 0; i < speedUptwo.length; i++) {
        for (let j = 0; j < speedUptwo[i].length; j++) {
          time4 += speedUptwo[i][j][1];
          total4 += speedUptwo[i][j][1] * speedUptwo[i][j][2];
        }
        if (total4 / time4 == "Infinity" || speedUptwo[i].length == 0) {
          this.checkedData[i].speed4 = 0;
        } else {
          this.checkedData[i].speed4 = Math.abs((total4 / time4).toFixed(2));
        }
        time4 = 0;
        total4 = 0;
      }
      this.checkedData.startDate = moment(
        this.checkedData[0].beginTime * 1000
      ).format("YYYY-MM-DD HH:mm:ss");
      this.checkedData.endDate = moment(
        this.checkedData[this.checkedData.length - 1].endTime * 1000
      ).format("YYYY-MM-DD HH:mm:ss");
      this.checkedData.milePartNo =
        this.checkedData[this.checkedData.length - 1].milePartNo;

      this.checkedId = [];
      for (var i = 0; i < e.length; i++) {
        this.checkedId.push(e[i]._id);
      }
      if (e.length == this.tableData.length) {
        this.totalChecked = true;
      } else if (this.totalChecked) {
        this.totalChecked = false;
      }
    },
    totalChange(e) {
      if (!e) {
        this.$refs.table.clearSelection();
      } else {
        this.$refs.table.clearSelection();
        this.$refs.table.toggleAllSelection();
      }
    },
    // 钻头
    myFun(y) {
      var that = this;
      that.y = Number(y).toFixed(2);
      that.ztTop = 100 - (y / this.selectItem.depth.toFixed(2)) * 100 + "%";
    },
    // 天地图控件
    loadmap() {
      var T = window.T;
      this.map = new T.Map("mapDiv");
      //设置显示地图的中心点和级别
      this.map.centerAndZoom(
        new T.LngLat(this.selectItem.longitude, this.selectItem.latitude),
        10
      );
      const ctrl = new T.Control.MapType([
        {
          title: "地图",
          icon: "http://api.tianditu.gov.cn/v4.0/image/map/maptype/vector.png", //地图控件上所要显示的图层图标（默认图标大小80x80）
          layer: window.TMAP_NORMAL_MAP,
        },
        {
          title: "卫星",
          icon: "http://api.tianditu.gov.cn/v4.0/image/map/maptype/satellite.png",
          layer: window.TMAP_SATELLITE_MAP,
        },
      ]);
      // 6.将控件添加到地图，一个控件实例只能向地图中添加一次。
      this.map.addControl(ctrl);
      // 创建坐标
      const point = new T.LngLat(
        this.selectItem.longitude,
        this.selectItem.latitude
      );
      // 8.创建覆盖使用的图标
      const icon = new T.Icon({
        iconUrl: "@/assets/images/map/b4.png",
      });
      // 9. 创建在该坐标上的一个图像标注实例
      const marker = new T.Marker(point, icon);
      // 10.将覆盖物添加到地图中，一个覆盖物实例只能向地图中添加一次
      this.map.addOverLay(marker);
      //允许鼠标双击放大地图
      this.map.enableScrollWheelZoom();
    },
  },
};
</script>
<style scoped>
.export_echart {
  cursor: pointer;
  font-size: 0.75rem;
  background: #409eff;
  text-align: center;
  width: 80px;
  height: 32px;
  line-height: 32px;
  margin-top: 14px;
  border-radius: 4px;
  color: #fff;
  float: left;
}
.m-tab-echartTable {
  position: relative;
}
.echatrs {
  position: absolute;
  top: 0;
  left: -2000px;
  width: 800px;
  height: 660px;
}

/* 历史回放 */
.backplayBottom {
  margin-top: 5px;
  background: #fff;
  height: 3rem;
  display: flex;
  justify-content: space-between;
}
/* >>> .el-input--small .el-input__inner {
  color: #211b1b;
} */
.iconBack {
  color: #211b1b;
  /* color: #409eff; */
  font-size: 28px;
  font-weight: bold;
  line-height: 3.2rem;
}
.progress_bar {
  width: 74%;
  margin-top: 20px;
}
.selectspeed {
  width: 120px;
  margin-top: 10px;
}

.backEchart {
  background: #fff;
  height: 20rem;
  margin: 5px 0 5px 5px;
  border-radius: 10px;
}
.m-statusinfo {
  background: #fff;
  box-shadow: none;
}
.m-datab1 .top {
  margin-bottom: 0px;
}
.picbox .data {
  bottom: 97%;
}
.picbox .databar {
  bottom: 7px;
}
.m-datab1 {
  background: #fff;
  border-radius: 10px;
  margin-left: 5px;
  padding-top: 0.8rem;
}
.mapDiv {
  width: 100%;
  height: 100%;
}
/* 历史回放end */
/* 更多条件 */
.moreConditions {
  display: flex;
  width: 100%;
  justify-content: space-around;
  padding-bottom: 20px;
}
.moreConditions .item,
.moreConditions .items {
  line-height: 40px;
}
.moreConditions .input {
  width: 38%;
}
/* 更多条件 */
.el-button--primary {
  margin-left: 25px;
  margin-right: 5px;
}

.el-checkbox {
  width: 20%;
}
.more {
  margin-left: 1.75rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAbCAYAAAB836/YAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo4MUQ5MUJCNkEzRkYxMUVCQTE1NUVDNDc5MDNFOTc4OSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo4MUQ5MUJCN0EzRkYxMUVCQTE1NUVDNDc5MDNFOTc4OSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjgxRDkxQkI0QTNGRjExRUJBMTU1RUM0NzkwM0U5Nzg5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjgxRDkxQkI1QTNGRjExRUJBMTU1RUM0NzkwM0U5Nzg5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+B0oTKQAAAE9JREFUeNpi/P//PwM1ARMDlcGogUPUQE8gfgbFnoQUMxKRDkEGSULZz4FYippeZqSGl1OA+AUQPwXiZGp4eTQdjibs0YQ9mg5HgoEAAQYAMKsdCdjHQ/QAAAAASUVORK5CYII=)
    center center no-repeat;
  background-size: contain;
  float: left;
  border-radius: 0.3125rem;
  -webkit-border-radius: 0.3125rem;
  -moz-border-radius: 0.3125rem;
  -ms-border-radius: 0.3125rem;
  -o-border-radius: 0.3125rem;
  overflow: hidden;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  cursor: pointer;
}

.jbThead {
  font-size: 14px;
  color: #515a6e;
}

.ul-detail .inner {
  padding: 0.625rem 0 0.625rem 0.3rem;
}
.ul-detail .s3 .tit {
  min-width: 10em;
}
.ul-detail .s1 .tit {
  margin-right: 0;
  min-width: 5em;
}
.valuepile {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 历史记录 详情 详细数据下的padding值 */
.ul-detail li {
  padding: 0 1.3rem 0 0;
}
.ul-detail li:first-child {
  padding-left: 1.3rem;
}

.export-dialog-buttons {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}

.export-dialog-buttons .el-button--primary {
  margin-left: 5px;
  margin-right: 5px;
}
</style>

